var _path, _path2, _path3, _circle, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.1528C0 27.952 3.48481 25.9689 6.23662 27.6036L25.7029 39.1677C29.6522 41.5139 32.073 45.7676 32.073 50.3613V65.8655C32.073 69.0662 28.5882 71.0494 25.8363 69.4147L6.37009 57.8505C2.42074 55.5044 0 51.2507 0 46.657V31.1528Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.1528C0 27.952 3.48481 25.9689 6.23662 27.6036L25.7029 39.1677C29.6522 41.5139 32.073 45.7676 32.073 50.3613V65.8655C32.073 69.0662 28.5882 71.0494 25.8363 69.4147L6.37009 57.8505C2.42074 55.5044 0 51.2507 0 46.657V31.1528Z",
    fill: "url(#paint0_linear_1_115644)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8619 31.1526C69.8619 27.9518 66.3771 25.9687 63.6253 27.6034L44.159 39.1675C40.2097 41.5137 37.7889 45.7674 37.7889 50.3611V65.8653C37.7889 69.066 41.2738 71.0492 44.0256 69.4145L63.4918 57.8504C67.4412 55.5042 69.8619 51.2505 69.8619 46.6568V31.1526Z",
    fill: "url(#paint1_linear_1_115644)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.9313,
    cy: 23.8986,
    r: 10.1617,
    fill: "url(#paint2_linear_1_115644)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5922 21.9167L57.0424 23.8177C57.0235 23.8839 56.9838 23.9422 56.9292 23.9841C56.8745 24.0261 56.8079 24.0494 56.7391 24.0506C56.6702 24.0518 56.6028 24.0309 56.5467 23.9909C56.4907 23.9509 56.4489 23.894 56.4276 23.8285L55.811 21.9482C55.56 21.1823 55.1257 20.4894 54.5459 19.9296C53.9661 19.3698 53.2583 18.9602 52.484 18.7363L50.5831 18.1873C50.5166 18.1685 50.4579 18.1288 50.4158 18.0741C50.3736 18.0194 50.3502 17.9526 50.349 17.8836C50.3477 17.8145 50.3688 17.7469 50.409 17.6908C50.4492 17.6346 50.5064 17.5929 50.5722 17.5718L52.4525 16.9558C53.2184 16.7048 53.9113 16.2706 54.4711 15.6907C55.0309 15.1109 55.4405 14.4031 55.6644 13.6289L56.2134 11.7272C56.2322 11.6607 56.2719 11.6021 56.3266 11.5599C56.3813 11.5178 56.4481 11.4943 56.5171 11.4931C56.5862 11.4919 56.6538 11.5129 56.7099 11.5531C56.7661 11.5933 56.8078 11.6505 56.8289 11.7163L57.4449 13.5974C57.696 14.3631 58.1303 15.0559 58.7101 15.6156C59.2899 16.1752 59.9977 16.5847 60.7718 16.8085L62.6735 17.3583C62.7397 17.3772 62.7981 17.4169 62.84 17.4716C62.8819 17.5262 62.9052 17.5928 62.9065 17.6616C62.9077 17.7305 62.8868 17.7979 62.8468 17.854C62.8068 17.91 62.7499 17.9518 62.6844 17.9731L60.8034 18.5897C60.0376 18.8408 59.3448 19.2751 58.7852 19.855C58.2255 20.4348 57.816 21.1425 57.5922 21.9167Z",
    fill: "url(#paint3_linear_1_115644)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0277 21.9167L13.478 23.8177C13.459 23.8839 13.4193 23.9422 13.3647 23.9841C13.3101 24.0261 13.2435 24.0494 13.1746 24.0506C13.1058 24.0518 13.0384 24.0309 12.9823 23.9909C12.9262 23.9509 12.8845 23.894 12.8632 23.8285L12.2465 21.9482C11.9955 21.1823 11.5613 20.4894 10.9814 19.9296C10.4016 19.3698 9.69381 18.9602 8.91959 18.7363L7.0186 18.1873C6.95214 18.1685 6.89348 18.1288 6.85132 18.0741C6.80916 18.0194 6.78574 17.9526 6.78452 17.8836C6.78329 17.8145 6.80434 17.7469 6.84454 17.6908C6.88474 17.6346 6.94195 17.5929 7.00771 17.5718L8.88808 16.9558C9.65394 16.7048 10.3469 16.2706 10.9067 15.6907C11.4664 15.1109 11.8761 14.4031 12.1 13.6289L12.649 11.7272C12.6677 11.6607 12.7074 11.6021 12.7621 11.5599C12.8168 11.5178 12.8836 11.4943 12.9527 11.4931C13.0217 11.4919 13.0893 11.5129 13.1455 11.5531C13.2017 11.5933 13.2434 11.6505 13.2645 11.7163L13.8805 13.5974C14.1315 14.3631 14.5659 15.0559 15.1457 15.6156C15.7255 16.1752 16.4332 16.5847 17.2074 16.8085L19.1091 17.3583C19.1753 17.3772 19.2336 17.4169 19.2756 17.4716C19.3175 17.5262 19.3408 17.5928 19.342 17.6616C19.3432 17.7305 19.3223 17.7979 19.2823 17.854C19.2424 17.91 19.1854 17.9518 19.12 17.9731L17.2389 18.5897C16.4732 18.8408 15.7804 19.2751 15.2207 19.855C14.6611 20.4348 14.2515 21.1425 14.0277 21.9167Z",
    fill: "url(#paint4_linear_1_115644)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6013 6.58414L35.2577 7.77227C35.2459 7.81364 35.2211 7.85012 35.1869 7.87632C35.1528 7.90253 35.1111 7.91709 35.0681 7.91785C35.0251 7.91861 34.983 7.90554 34.9479 7.88055C34.9129 7.85557 34.8868 7.82 34.8735 7.77907L34.4881 6.60385C34.3312 6.12518 34.0598 5.69209 33.6974 5.34223C33.335 4.99237 32.8926 4.73635 32.4087 4.59642L31.2206 4.25327C31.1791 4.24155 31.1424 4.21676 31.1161 4.18257C31.0897 4.14838 31.0751 4.10662 31.0743 4.06346C31.0735 4.02031 31.0867 3.97805 31.1118 3.94295C31.1369 3.90786 31.1727 3.88178 31.2138 3.86859L32.389 3.48361C32.8677 3.32675 33.3008 3.05532 33.6507 2.69294C34.0005 2.33055 34.2565 1.88817 34.3965 1.40428L34.7396 0.215723C34.7513 0.174184 34.7761 0.137526 34.8103 0.111175C34.8445 0.0848252 34.8863 0.0701845 34.9294 0.0694206C34.9726 0.0686566 35.0148 0.0818102 35.0499 0.106934C35.085 0.132058 35.1111 0.167816 35.1243 0.208914L35.5093 1.38459C35.6662 1.86317 35.9376 2.29618 36.3 2.64595C36.6624 2.99573 37.1048 3.25169 37.5886 3.39157L38.7772 3.73515C38.8185 3.747 38.855 3.77182 38.8812 3.80595C38.9074 3.84008 38.922 3.88173 38.9227 3.92476C38.9235 3.96778 38.9104 4.00992 38.8854 4.04496C38.8605 4.08 38.8249 4.10609 38.784 4.11939L37.6083 4.50482C37.1297 4.66174 36.6967 4.9332 36.3469 5.29558C35.9971 5.65796 35.7412 6.1003 35.6013 6.58414Z",
    fill: "url(#paint5_linear_1_115644)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_115644",
    x1: 1.68342,
    y1: 27.0181,
    x2: 76.6578,
    y2: 40.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2ECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_115644",
    x1: 69.0891,
    y1: 23.8985,
    x2: 33.7723,
    y2: 26.3993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2ECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_115644",
    x1: 36.6177,
    y1: 13.7368,
    x2: 36.6177,
    y2: 34.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEAB35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7B1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_115644",
    x1: 62.715,
    y1: 23.9448,
    x2: 48.9539,
    y2: 22.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2ECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_115644",
    x1: 19.1505,
    y1: 23.9448,
    x2: 5.38945,
    y2: 22.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2ECA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_115644",
    x1: 38.8031,
    y1: 7.85174,
    x2: 30.2024,
    y2: 7.07086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13EED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F2ECA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1eea3fb0a6a87b0231d4cae53921deda.svg";
export { ForwardRef as ReactComponent };